export const ImportExportModuleTranslations: Array<string> = [
    'Admin.BulkImportExportProductTranslations.ExportProductTranslations',
    'Admin.BulkImportExportProductTranslations.SelectWhatToExport',
    'Admin.ImportExport.ExportTemplate',
    'Admin.BulkImportExportProductTranslations.ExportTemplate',
    'Admin.BulkImportExportProductTranslations.ExportAllProductTranslations',
    'Admin.BulkImportExportProductTranslations.ExportAll',
    'Admin.ImportExport.FilterAndExport',
    'Admin.BulkImportExportProductTranslations.ImportProductTranslations',
    'ImportExport.Admin.ProductIdentifier',
    'ProductTranslationImport.SpecifyIdentifier',
    'Admin.BulkImportExportProductTranslations.Jobs',
    'xmlBulkProductTranslationsImportExport',

    'Msg.Download',
    'Admin.ImportExport.Type',
    'Admin.ImportExport.RunnedBy',
    'Admin.ImportExport.EmailMeWhenDone',
    'Admin.ImportExport.Progress',
    'Admin.ImportExport.Status',
    'Admin.ImportExport.FileTooBig',

    'Admin.BulkImportExportProductTranslations.SelectLanguages',
    'Admin.BulkImportExportProductTranslations.Languages',
    'Admin.BulkImportExportProductTranslations.ProductObject',
    'Admin.BulkImportExportProductTranslations.ProductName',
    'Admin.BulkImportExportProductTranslations.Description',
    'Admin.BulkImportExportProductTranslations.LongDescription',
    'Admin.BulkImportExportProductTranslations.DescriptionBuilder',
    'Admin.BulkImportExportProductTranslations.AttributeObject',
    'Admin.BulkImportExportProductTranslations.Label',
    'Admin.BulkImportExportProductTranslations.Hint',
    'Admin.BulkImportExportProductTranslations.ErrorMessage',
    'Admin.BulkImportExportProductTranslations.AttributeValueObject',
    'Admin.BulkImportExportProductTranslations.AttributeValueLineItemDescription',
    'Admin.BulkImportExportProductTranslations.AttributeValueDescription',
    'Msg.Export',
    'Admin.ImportExport.TooltipWithNote',

    'Admin.ImportExport.EnterValues',
    'Admin.ImportExport.EnterValue',
    'Admin.ImportExport.FilterExportBy',
    'Admin.BulkImportExportProductTranslations.ProductFieldsAndLanguages',
    'xsltPartNumber',
    'xsltName',
    'xsltDescription',
    'Admin.CategoryML.Title',
    'Admin.ImportExport.Required',
    'Admin.ImportExport.SelectCategories',
    'Admin.BulkImportExportProductTranslations.DisplayType',
    'Admin.BulkImportExportProductTranslations.ActiveVersion',
    'Admin.BulkImportExportProductTranslations.ModifiedDate',
    'Admin.BulkImportExportProductTranslations.ModifiedBy',
    'Admin.BulkImportExportProductTranslations.Active',
    'Admin.BulkImportExportProductTranslations.SyncedFromBackOffice',
    'Admin.BulkImportExportProductTranslations.AliasOf',
    'Admin.BulkImportExportProductTranslations.SystemId',
    'Admin.ImportExport.ApplyFilterAndExport',
    'ProductList.ChooseCategories',
    'Admin.ImportExport.SelectPermissions',
    'Admin.ImportExport.Permissions',
    'Admin.BulkExportProductTranslation.NoSelectedDictionary',
    'Admin.BulkExportProductTranslation.ExportScheduled',
    'Admin.ImportExport.ProductTypes',
    'xsltDateModifiedFrom',
    'xsltDateModifiedTo',

    'Admin.BulkImportExport.Queued',
    'Admin.BulkImportExport.InProgress',
    'Admin.BulkImportExport.Finished',
    'Admin.BulkImportExport.Canceled',
    'Admin.BulkImportExport.Failed',
    'Admin.BulkImportExport.Canceling',
    'Admin.BulkImportExport.FinishedWithErrors',

    //Bulk Import Export Business Partners
    'xmlBulkBusinessPartnersImportExport',
    'BusinessPartnerExportImportNotificationBodySuccess',
    'Admin.BusinessPartnerExportImportNotificationBodyFailure',
    'Admin.BusinessPartnerExportImportNotificationSubject',    
    'Admin.BulkExportBusinessPartner.NoFileFound',
    'Admin.BulkImportExportBusinessPartner.ExportBusinessPartners',
    'Admin.BulkImportExportBusinessPartner.SelectWhatToExport',
    'Admin.BulkImportExportBusinessPartner.ExportAllBusinessPartners',
    'Admin.BulkImportExportBusinessPartner.ImportBusinessPartners',
    'ImportExport.Admin.BusinessPartnerIdentifier',
    'Admin.BulkImportExportBusinessPartners.ExportTemplate',
    'Admin.BulkImportExportBusinessPartner.ExportAll',
    'Admin.BulkExportBusinessPartners.ExportScheduled',
    'Admin.BulkImportBusinessPartners.ImportScheduled',
    'BusinessPartnerImport.SpecifyIdentifier'
    
]
